import { useNavigate } from "react-router-dom";

export default function PcTopBar({title, theme, rightContent}: {title: string, theme: 'light' | 'dark', rightContent?: React.ReactNode}) {
    const navigate = useNavigate();

    return (
        <div className="container mx-auto flex items-center justify-between px-6 py-4">
            <div 
              className="flex items-center cursor-pointer" 
              onClick={() => {
                  navigate(-1);
              }}
            >
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-neutral-800">
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${theme === 'light' ? 'text-neutral-200' : 'text-neutral-900'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </div>
              <span className="ml-2 text-lg font-medium text-white">{title}</span>
            </div>
            {rightContent}
          </div>
    )
}
